import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MuiToggleValue, ToggleComponentBase } from '../toggle';


let nextUniqueId = 0;

@Component({
  selector: 'mui-switch',
  templateUrl: './mui-switch.component.html',
  styleUrls: ['./mui-switch.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MuiSwitch),
      multi: true
    }
  ]
})
export class MuiSwitch extends ToggleComponentBase {

  @Input()
  labelPosition: 'before' | 'after' = 'before';

  get inputId(): string {
    return this.id + '-input';
  }

  protected _uid = `mui-switch-${nextUniqueId++}`;

  constructor() {
    super();
  }

  writeValue(value: MuiToggleValue): void {
    super.writeValue(value);
  }
}
